import ArrowLeft16 from '@carbon/icons-react/es/arrow--left/16';
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import PresentationFile16 from '@carbon/icons-react/es/presentation-file/16';
import ShrinkScreen16 from '@carbon/icons-react/es/shrink-screen/16';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

export const Action = styled.div`
  margin-left: var(--spacing-05);
  && .ant-btn svg {
    margin: unset;
  }
`;

export const ProjectPlanFullscreenToggle: FC<{
  canForward: boolean;
  canBackward: boolean;
  isFullScreen: boolean;
  onBackward: () => void;
  onExitFullScreen: (value) => void;
  onForward: () => void;
  onFullScreen: (value) => void;
}> = ({
  canBackward,
  canForward,
  isFullScreen,
  onBackward,
  onExitFullScreen,
  onForward,
  onFullScreen,
}) => {
  const { pathname } = useLocation();

  return (
    <Action>
      {isFullScreen && !pathname.includes('timeline') ? (
        <>
          <Button
            type="text"
            icon={<ArrowLeft16 />}
            onClick={onBackward}
            disabled={!canBackward}
            data-cy="present_phase.left"
          />
          <Button
            type="text"
            icon={<ArrowRight16 />}
            onClick={onForward}
            disabled={!canForward}
            data-cy="present_phase.right"
          />
        </>
      ) : null}

      <Button
        type="text"
        icon={isFullScreen ? <ShrinkScreen16 /> : <PresentationFile16 />}
        onClick={isFullScreen ? onExitFullScreen : onFullScreen}
        data-cy="present_phase.exit"
      />
    </Action>
  );
};
